import { Button, icon, Modal, ModalFooter, ModalTitle } from "@hm/fundamental"
import { useTranslation } from "react-i18next"

interface CommentDeleteModalProps {
	isOpen: boolean
	isSubmitting: boolean
	onConfirm: () => void
	onCancel: () => void
}

export const CommentDeleteModal: React.FC<CommentDeleteModalProps> = ({
	isOpen,
	isSubmitting,
	onConfirm,
	onCancel,
}) => {
	const { t } = useTranslation("shared", {
		keyPrefix: "commentBox.deleteModal",
	})

	return (
		<Modal
			data-cy="comment-delete-modal"
			open={isOpen}
			onClose={() => !isSubmitting && onCancel()}
		>
			<ModalTitle data-cy="comment-delete-modal-title">
				{t("title")}
			</ModalTitle>
			<ModalFooter>
				<Button
					data-cy="comment-delete-cancel"
					variant="secondary"
					type="button"
					icon={icon.mdiClose}
					onClick={() => !isSubmitting && onCancel()}
					disabled={isSubmitting}
				>
					{t("cancel")}
				</Button>
				<Button
					data-cy="comment-delete-confirm"
					variant="negative"
					type="submit"
					icon={icon.mdiDelete}
					onClick={() => !isSubmitting && onConfirm()}
					disabled={isSubmitting}
				>
					{t("delete")}
				</Button>
			</ModalFooter>
		</Modal>
	)
}
